import { Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { FrontendErrorService } from '@services/frontend-error/frontend-error.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PackageSelectorComponent } from '../../components/package-selector/package-selector.component';

@Component({
    selector: 'app-frontend-errorlog',
    templateUrl: './frontend-errorlog.component.html',
    styleUrls: ['./frontend-errorlog.component.scss'],
    providers: [FrontendErrorService],
    standalone: false
})
export class FrontendErrorlogComponent implements OnInit {

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public frontendType = 'ng-ibexfusion';

  public subtitle: string;
  public title = 'Frontend Errors: ';
  public pageActions: PageAction[];

  public columns = [
    { prop: 'destination', name: 'PalayoutId' },
    {
      prop: 'route', name: 'System', valueTransformer: data => {
        if (data.includes('beta.') || data.includes('messengerstaging.')) {
          return 'beta';
        } else if (data.includes('messenger.')) {
          return 'messenger';
        } else if (data.includes('preview.')) {
          return 'preview';
        } else {
          return 'live';
        }
      }
    },
    {
      prop: 'route', name: 'Playout', valueTransformer: data => {
        if (!data.includes('.ch')) {
          return data;
        }
        return data.split('.ch/')[1].split('/')[0];
      }
    },
    {
      prop: 'created', name: 'Date', valueTransformer: function(date) {
        return moment(date).fromNow();
      }, hover: function(data) {
        return moment(data.created).format('DD.MM.YYYY - HH:mm');
      }
    },
    { prop: 'errorMessage', name: 'Message' }
  ];

  public searchColumns = [ { prop: 'route' }, { prop: 'destination' }, { prop: 'errorMessage' } ];

  params: any = {};

  constructor(private router: Router, private route: ActivatedRoute, public frontendErrorService: FrontendErrorService, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.pageActions = [new PageAction({ icon: 'filter_alt', title: 'Filter by Playout', callback: () => this.filterByPlayout() })];
    this.frontendType = this.route.snapshot.data.params['frontendType'];
    this.params = { frontendType: this.frontendType, $sort: { created: -1 } };
    this.title += this.frontendType;

    if (this.frontendType === 'ng-ibexfusion') {
      this.columns[0] = { prop: 'org', name: 'Organisation' };
      this.columns.splice(1, 0, { prop: 'errorStatus', name: 'Status' });
    }
  }

  onDetail(event: DataTableEvent) {
    this.router.navigate(['frontend-errorlog/', this.frontendType, event.row._id]);
  }

  async filterByPlayout() {
    let dialogRef: MatDialogRef<PackageSelectorComponent>;
    dialogRef = this.dialog.open(PackageSelectorComponent, { width: '700px', height: '660px', data: { type: 'image', disableCheckSize: true } });
    const pak = await dialogRef.afterClosed().toPromise();
    this.pageActions = [new PageAction({ icon: 'filter_alt', title: 'Filter by Playout', callback: () => this.filterByPlayout() })];
    if (!!pak) {
      this.params = { destination: pak?._id?.toString(), frontendType: this.frontendType, $sort: { created: -1 } };
      this.pageActions.push(new PageAction({ icon: 'delete', title: 'Reset Filter', callback: () => this.params = {} }));
    } else {
      this.params = { frontendType: this.frontendType, $sort: { created: -1 } };
    }
  }
}
